<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Edit Persona"
    seFeDataSubtitle="Edit persona information"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div class="docs-content">
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="Description"></se-fe-card-header>
        <se-fe-card-content>
          <p>Used when a form is presented to edit profile information. (see <a routerLink="/apps/se-persona-picker">persona-picker</a>)</p>
          <p>Uses the following ui-components</p>
          <ul>
            <li>
              <a routerLink="/libs/ui-contact-info">&#64;se-po/shared-ui-contact-info</a>
            </li>
            <li>
              <a routerLink="/libs/ui-persona-info">&#64;se-po/shared-ui-persona-info</a>
            </li>
          </ul>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card>
        <se-fe-card-header seFeDataTitle="EditPersonaComponent"></se-fe-card-header>
        <se-fe-card-content>
          <se-fe-docs-table
            [seFeDataHeaders]="headers"
            [seFeDataRows]="editPersonaComponent">
          </se-fe-docs-table>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card>
        <se-fe-card-header seFeDataTitle="Edit Persona Info Self Example"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-edit-persona-self-example></se-po-edit-persona-self-example>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card>
        <se-fe-card-header seFeDataTitle="Edit Persona Info Sub Profile Example"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-edit-persona-child-example></se-po-edit-persona-child-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
